module.exports = __webpack_public_path__ + "img/sketch.30a9c4e4.jpg";